import { FULL_DAYS, type FullDay } from "../data/days";
import { schedule } from "../data/schedule";
import { T } from "../styles/theme";
import type { CheckedMap } from "../types";

interface WeekAtGlanceProps {
  activeDay: FullDay;
  checked: CheckedMap;
  onSwitchDay: (day: FullDay) => void;
}

/** Purple "week at a glance" summary card at the bottom of the daily view. */
export function WeekAtGlance({ activeDay, checked, onSwitchDay }: WeekAtGlanceProps) {
  return (
    <div
      style={{
        background: "linear-gradient(135deg,#3d1e5c,#6b3fa0,#a05a8b)",
        borderRadius: 20,
        padding: "16px 18px",
        marginTop: 12,
        boxShadow: `0 6px 24px ${T.terra}40`,
      }}
    >
      <div
        style={{
          fontSize: 9,
          letterSpacing: 3,
          color: "rgba(255,255,255,0.6)",
          textTransform: "uppercase",
          marginBottom: 12,
          fontWeight: 700,
        }}
      >
        Week at a Glance
      </div>
      {FULL_DAYS.map((day) => {
        const d = schedule[day];
        const n = d.tasks.filter((t) => t.id && checked[t.id]).length;
        const p = Math.round((n / d.tasks.length) * 100);
        return (
          <div
            key={day}
            style={{ display: "flex", alignItems: "center", gap: 9, marginBottom: 8, cursor: "pointer" }}
            onClick={() => onSwitchDay(day)}
          >
            <div style={{ width: 22, fontSize: 13 }}>{d.emoji}</div>
            <div
              style={{
                width: 42,
                fontSize: 9,
                fontWeight: day === activeDay ? 700 : 400,
                letterSpacing: 1,
                color: day === activeDay ? "#fff" : "rgba(255,255,255,0.55)",
                textTransform: "uppercase",
              }}
            >
              {day.slice(0, 3)}
            </div>
            <div
              style={{
                flex: 1,
                height: 5,
                background: "rgba(255,255,255,0.15)",
                borderRadius: 99,
                overflow: "hidden",
              }}
            >
              <div
                style={{
                  height: "100%",
                  width: `${p}%`,
                  background: p === 100 ? T.sageLight : "rgba(255,255,255,0.6)",
                  borderRadius: 99,
                  transition: "width 0.4s",
                }}
              />
            </div>
            <div style={{ fontSize: 9, color: "rgba(255,255,255,0.7)", width: 30, textAlign: "right" }}>
              {n}/{d.tasks.length}
            </div>
          </div>
        );
      })}
    </div>
  );
}
